/**
 * Der Einstiegspunkt.
 *
 * **Absichtlich dünn**: einhängen, den Transport bereitstellen, die Übersetzungen laden. Alles,
 * was eine Entscheidung ist, liegt in den Schichten darunter — dieselbe Aufteilung wie in
 * `apps/server/src/index.ts`.
 *
 * `StrictMode` ist eingeschaltet: er ruft Effekte in der Entwicklung doppelt auf und findet
 * damit genau die Fehler, die später als „manchmal doppelt gesendet" auffallen würden.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';

import { App } from './App.js';
import { ApiProvider } from './api/context.js';
import { i18n } from './i18n/index.js';

// Das Stylesheet wird **hier** eingehängt und nirgends sonst: eine Oberfläche, ein Satz Werte
// (Zyklus D2b). Import und nicht `<link>` in der `index.html`, damit Vite es in den Build
// aufnimmt und im Entwicklungsbetrieb nachlädt, ohne dass jemand an zwei Stellen denkt.
import './styles/app.css';

const root = document.getElementById('root');
if (root === null) {
  throw new Error('Das Wurzelelement fehlt — index.html passt nicht zu diesem Einstiegspunkt');
}

createRoot(root).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <ApiProvider>
        <App />
      </ApiProvider>
    </I18nextProvider>
  </StrictMode>,
);
